import { Requester, Listener } from '@deskdirector/post-message-proxy';
import { fromSearchObject } from '@deskdirector/deep-linking/lib/portal';

var TicketDataApi = /*#__PURE__*/function () {
  function TicketDataApi(requester) {
    this.requester = requester;
  }
  /**
   * Gets a ticket from Portal
   */


  var _proto = TicketDataApi.prototype;

  _proto.getTicket = function getTicket(ticketId) {
    var action = {
      type: 'portal.data.tickets.get',
      payload: {
        ticketId: ticketId
      }
    };
    return this.requester.postMessage(action);
  }
  /**
   * Adds a note to a ticket
   */
  ;

  _proto.addNote = function addNote(req) {
    var action = {
      type: 'portal.data.tickets.add-note',
      payload: req
    };
    return this.requester.postMessage(action);
  }
  /**
   * Finds tickets based on search and filter criteria
   */
  ;

  _proto.findTickets = function findTickets(req) {
    var action = {
      type: 'portal.data.tickets.find',
      payload: req
    };
    return this.requester.postMessage(action);
  };

  return TicketDataApi;
}();

/**
 * Apis to request data from Portal
 */

var DataApi = function DataApi(requester) {
  this.tickets = new TicketDataApi(requester);
};

/**
 * Allows deeplinks to be sent to Portal. These can navigate to most areas of the app.
 */
var NavigationApi = /*#__PURE__*/function () {
  function NavigationApi(requester) {
    this.requester = requester;
  }
  /**
   * Send a deeplink to Portal. More information on deeplinks can be found at
   * https://help.deskdirector.com/article/rb70qsabfd-portal-deep-linking
   */


  var _proto = NavigationApi.prototype;

  _proto.deeplink = function deeplink(_deeplink) {
    var action = {
      type: 'portal.deeplink',
      payload: _deeplink
    };
    return this.requester.postMessage(action);
  }
  /**
   * Performs a refresh of the parent page
   */
  ;

  _proto.refreshPage = function refreshPage() {
    var action = {
      type: 'portal.refresh'
    };
    return this.requester.postMessage(action);
  };

  return NavigationApi;
}();

/**
 * Api which provides methods to send postMessage requests to Portal. Portal implements receivers
 * which respond to these requests.
 */

var PortalApi = /*#__PURE__*/function () {
  function PortalApi(
  /**
   * Reference to the Portal window. Usually this is `window.parent`.
   */
  portalWindow,
  /**
   * The origin where you expect the Portal window's document to be loaded. Avoid using "*" as
   * this can open your app up to message interception and tampering.
   *
   * Reference: https://developer.mozilla.org/en-US/docs/Web/API/Window/postMessage
   */
  origin,
  /**
   * The window where your app is running. This defaults to `window` so you usually don't need to
   * provide this parameter.
   *
   * @default window
   */
  hostWindow,
  /**
   * The maximum wait time for responses from the Portal window. If no response is received in
   * time api request promises will reject.
   *
   * @default 10000 (10 seconds)
   */
  responseTimeout) {
    if (hostWindow === void 0) {
      hostWindow = window;
    }

    if (responseTimeout === void 0) {
      responseTimeout = 10000;
    }

    var requester = this.requester = new Requester(portalWindow, origin, hostWindow, responseTimeout);
    this.navigation = new NavigationApi(requester);
    this.data = new DataApi(requester);
  }

  var _proto = PortalApi.prototype;

  _proto.userKey = function userKey() {
    var action = {
      type: 'portal.user_key'
    };
    return this.requester.postMessage(action);
  };

  return PortalApi;
}();

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }

  return _construct.apply(null, arguments);
}

function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;

  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;

    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }

    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);

      _cache.set(Class, Wrapper);
    }

    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }

    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };

  return _wrapNativeSuper(Class);
}

var NotImplementedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose(NotImplementedError, _Error);

  function NotImplementedError(handlerName) {
    return _Error.call(this, handlerName + " has not been implemented in target Window") || this;
  }

  return NotImplementedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
var notImplementedHandler = function notImplementedHandler(handlerName) {
  return function () {
    return Promise.reject(new NotImplementedError(handlerName));
  };
};

var isPortalDeepLinkAction = function isPortalDeepLinkAction(data) {
  if (data.type !== 'portal.deeplink') {
    return false;
  }

  var deeplink = fromSearchObject(data.payload);

  if (deeplink == null) {
    return false;
  }

  return true;
};

var isRefreshAction = function isRefreshAction(data) {
  return data.type === 'portal.refresh';
};

var isGetTicketAction = function isGetTicketAction(data) {
  return data.type === 'portal.data.tickets.get';
};
var isFindTicketsAction = function isFindTicketsAction(data) {
  return data.type === 'portal.data.tickets.find';
};
var isAddNoteAction = function isAddNoteAction(data) {
  return data.type === 'portal.data.tickets.add-note';
};

function isUserKeyAction(data) {
  return typeof data === 'object' && data.type === 'portal.user_key';
}

var TicketCategory;

(function (TicketCategory) {
  TicketCategory["All"] = "";
  TicketCategory["Own"] = "own";
  TicketCategory["ApprovalRequired"] = "approval.required";
  TicketCategory["ApprovalDeclined"] = "approval.declined";
  TicketCategory["ApprovalGranted"] = "approval.granted";
})(TicketCategory || (TicketCategory = {}));

var TicketState;

(function (TicketState) {
  TicketState["All"] = "";
  TicketState["Open"] = "open";
  TicketState["Closed"] = "closed";
})(TicketState || (TicketState = {}));

var TicketDataReceiver = function TicketDataReceiver(listener) {
  var _this = this;

  this.listener = listener;
  this.onGetTicket = notImplementedHandler('getTicket');
  this.onAddNote = notImplementedHandler('addNote');
  this.onFindTickets = notImplementedHandler('findTickets');
  this.listener.addHandler({
    test: isGetTicketAction,
    handle: function handle(data) {
      return _this.onGetTicket(data.payload.ticketId);
    }
  });
  this.listener.addHandler({
    test: isAddNoteAction,
    handle: function handle(data) {
      return _this.onAddNote(data.payload);
    }
  });
  this.listener.addHandler({
    test: isFindTicketsAction,
    handle: function handle(data) {
      return _this.onFindTickets(data.payload);
    }
  });
};

var DataReceiver = function DataReceiver(listener) {
  this.listener = listener;
  this.tickets = new TicketDataReceiver(this.listener);
};

var NavigationReceiver = function NavigationReceiver(listener) {
  var _this = this;

  this.listener = listener;
  this.deeplink = notImplementedHandler('deeplink');
  this.refreshPage = notImplementedHandler('refreshPage');
  this.listener.addHandler({
    test: isPortalDeepLinkAction,
    handle: function handle(data) {
      return _this.deeplink(data.payload);
    }
  });
  this.listener.addHandler({
    test: isRefreshAction,
    handle: function handle(_) {
      return _this.refreshPage();
    }
  });
};

var PortalReceiver = /*#__PURE__*/function () {
  function PortalReceiver(extensionWindow, origin, hostWindow) {
    var _this = this;

    if (hostWindow === void 0) {
      hostWindow = window;
    }

    this.extensionWindow = extensionWindow;
    this.origin = origin;
    this.hostWindow = hostWindow;
    this.userKey = notImplementedHandler('accessToken');
    var listener = this.listener = new Listener(this.extensionWindow, this.origin, [], this.hostWindow);
    this.data = new DataReceiver(listener);
    this.navigation = new NavigationReceiver(listener);
    listener.addHandler({
      test: isUserKeyAction,
      handle: function handle(_) {
        return _this.userKey();
      }
    });
  }

  var _proto = PortalReceiver.prototype;

  _proto.start = function start() {
    this.listener.start();
  };

  _proto.stop = function stop() {
    this.listener.stop();
  };

  return PortalReceiver;
}();

var UnexpectedMessageResultError = function UnexpectedMessageResultError(message, value) {
  this.message = message;
  this.value = value;
};

function ensureResult(value) {
  if (typeof value !== 'object' || !value.hasOwnProperty('status')) {
    throw new UnexpectedMessageResultError('Unexpected message result. Either value or value.status is not available', value);
  }

  var status = value.status;

  if (!Number.isSafeInteger(status)) {
    throw new UnexpectedMessageResultError('Unexpected message result, status is not integer', value);
  }
}

function isSuccess(value) {
  ensureResult(value);

  if (!value.hasOwnProperty('value')) {
    return false;
  }

  var result = value;
  return result.value != null;
}
function isError(value) {
  ensureResult(value);
  var result = value;
  return result.status >= 400 && result.error != null;
}
function isSuccessVoid(value) {
  ensureResult(value);
  return value.status >= 200 && value.status < 300;
}

export { DataApi, DataReceiver, NavigationApi, NavigationReceiver, NotImplementedError, PortalApi, PortalReceiver, TicketCategory, TicketDataApi, TicketDataReceiver, TicketState, UnexpectedMessageResultError, isAddNoteAction, isError, isFindTicketsAction, isGetTicketAction, isPortalDeepLinkAction, isRefreshAction, isSuccess, isSuccessVoid, isUserKeyAction, notImplementedHandler };
